import styled from 'styled-components';

import { ButtonSquare } from '@xsolla/ui-core';

export const FormWrapper = styled.div`
  > div:nth-child(odd) {
    margin-top: 24px;
  }
`;

export const ExtraButtonStyled = styled(ButtonSquare)`
  margin-left: 8px;
`;
